import { useTranslation, Trans } from "react-i18next";

import mainRight from '../../img/rec.png';

function Main() {
  const { t } = useTranslation();

  return (
    <>
      <div className="overflow-hidden relative bg-[#277423] xl:h-[770px] max-w-[1220px] mx-[20px] xl:mx-auto mt-[60px] xl:mt-0">
        {/* Full bg image - desktop */}

        {/* Right photo overlay - desktop */}
        <img src={mainRight} className="hidden xl:block absolute right-0 top-0 h-full w-[620px] object-cover" alt="" />
        {/* Mobile image */}
        <img src={mainRight} className="xl:hidden block w-full h-[300px] object-cover" alt="" />

        {/* Left text content */}
        <div className="relative z-10 flex flex-col items-start px-[20px] xl:px-[40px] pt-[20px] xl:pt-[130px]">
          <p className="host-grotesk text-[28px] xl:text-[40px] leading-[1.2] font-[300] text-white">{t('about.1')}</p>
          <p className="leading-[1.2] text-white text-[32px] xl:text-[64px] font-[600] host-grotesk">{t('home.1')}</p>
          <div className="bg-[#FFFFFF] h-px xl:w-[560px] w-full mt-[20px] xl:mt-[40px]"></div>
          <p className="mt-[20px] xl:mt-[40px] xl:max-w-[458px] PtRoot text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('about.2')}</p>
          <p className="mt-[16px] xl:max-w-[458px] PtRoot text-[12px] xl:text-[14px] text-[#FFFFFFB2]"><Trans>{t('about.3')}</Trans></p>
        </div>
      </div>
    </>
  );
}

export default Main;

